// extracted by mini-css-extract-plugin
export default {"discountBanner":"Jaa","topheader":"Kaa","navleft":"Laa","navflexelem":"Maa","navright":"Naa","fixedtop":"Oaa","abstop":"Paa","subdesc":"Qaa","smallscreennav":"Raa","nav_hidden":"Saa","cancel_link":"Taa","bottomnavcontainer":"Uaa","fixedbottom":"Vaa","animatedbottom":"Waa","appear-bottom":"Xaa","delayedbottom":"Yaa","retakebtn":"Zaa","long_banner":"aba","nofixed":"bba"};
    if(module.hot) {
      // 1714654900372
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  